'use client';

export { default } from '@alltrails/layout/components/GlobalErrorPage';
